/* theme.extras.js — split verbatim from Shrine main.js (deobfuscated 2026-10-14).
   Load order: theme.core → theme.cart → theme.search → theme.product → theme.deals → theme.extras → theme.license-guard. */

class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn");
    if (this.playButton) this.playButton.addEventListener("click", this.playVideo.bind(this));
    if (this.soundButton) this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    if (this.video) this.video.addEventListener("ended", this.endedVideo.bind(this));
    this.timeline && (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)), this.timeline.addEventListener("click", this.seekVideo.bind(this)), this.timeline.addEventListener("mousedown", this.startDrag.bind(this)), this.timeline.addEventListener("touchstart", this.startDrag.bind(this)), document.addEventListener("mouseup", this.stopDrag.bind(this)), document.addEventListener("touchend", this.stopDrag.bind(this)), document.addEventListener("mousemove", this.drag.bind(this)), document.addEventListener("touchmove", this.drag.bind(this)));
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const obj = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), obj);
      this.observer.observe(this);
    }
    this.fullscreenButton && (this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this)), document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this)));
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), this.loaded = true);
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      const play = this.video.play();
      play !== undefined && play.then(() => {
        this.classList.add("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      })["catch"](arg => {
        this.classList.remove("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
      });
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted ? (this.video.muted = false, this.classList.remove("internal-video--muted")) : (this.video.muted = true, this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const value = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", value + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(event) {
    event.preventDefault();
    this.dragging = true;
    this.drag(event);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(arg) {
    if (!this.dragging) return;
    arg.touches && (arg = arg.touches[0]);
    this.seekVideo(arg);
  }
  seekVideo(event) {
    const rect = this.timeline.getBoundingClientRect(),
      value = event.clientX - rect.left,
      value2 = value / rect.width;
    this.video.currentTime = value2 * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(arg) {
    arg.forEach(item => {
      if (item.isIntersecting) {
        for (let value of this.video.querySelectorAll("source[data-src]")) {
          value.setAttribute("src", value.getAttribute("data-src"));
          value.removeAttribute("data-src");
        }
        this.video.load();
        var play = this.video.play();
        play !== undefined && play["catch"](arg2 => {
          if (arg2.name === "NotAllowedError") {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
          }
        }).then(() => {
          this.video.play();
        });
        this.observer.disconnect();
      }
    });
  }
  toggleFullscreen() {
    document.fullscreenElement ? document.exitFullscreen() : this.requestFullscreen();
  }
  handleFullscreenChange() {
    document.fullscreenElement === this ? this.classList.add("internal-video--fullscreen") : this.classList.remove("internal-video--fullscreen");
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(event) {
    const value = event.currentTarget.value;
    this.sliderOverlay.style.width = value + "%";
    this.sliderLine.style.left = value + "%";
    this.style.setProperty("--position", value + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();else {
        const data = JSON.parse(localStorage.getItem(this.storageKey)),
          date2 = new Date(data.next_display_date);
        currentDate.getTime() > date2.getTime() && this.openPopupModal();
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach(item => {
      item.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      const addDaysResult = addDays(currentDate, parseInt(this.daysFrequency)),
        obj = {
          next_display_date: addDaysResult,
          dismissed: false
        };
      localStorage.setItem(this.storageKey, JSON.stringify(obj));
      if (this.timer) this.displayPromoTimer();
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const setIntervalResult = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1000);
  }
  updateTimer() {
    let floor = Math.floor(this.totalSeconds / 60);
    if (floor.toString().length === 1) floor = "0" + floor;
    let value = this.totalSeconds % 60;
    if (value.toString().length === 1) value = "0" + value;
    this.minutesSpan.innerText = floor;
    this.secondsSpan.innerText = value;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
